import React from "react";

class ScrollButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: 0,
      display: false
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll(event) {
    if (window.scrollY > 350) {
      this.setState({ display: true });
    }else{
      this.setState({ display: false });
    }
  }

  scrollStep() {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  scrollToTop() {
    let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({ intervalId: intervalId });
  }

  render() {
    return <button title="Back to top" className={this.state.display ? "btn-scroll" : "d-none"}
      onClick={() => { this.scrollToTop(); }}>
      <svg width="1em" height="1em" viewBox="0 0 16 16" className="icon" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"/>
      </svg>
    </button>;
  }
}

export default ScrollButton;